import { Translations, UUID } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Color } from './ColorApi';
import { ColorGroup } from './ColorGroupApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ArticleQuantityType {
	SUM = 'SUM',
	PACKAGES = 'PACKAGES',
	LENGTH = 'LENGTH',
	PACKAGE_AND_LENGTH = 'PACKAGE_AND_LENGTH',
}

export interface Article extends BaseEntity {
	name: string;
	code: string;
	unit: string;
	availableColors: Color[];
	availableColorsIds: UUID[];
	colorGroups: ColorGroup[];
	colorGroupsIds: UUID[];
	quantityType: ArticleQuantityType;
	packageSize: number;
	articleLengthMM: number;
	listOrder: number;
	translations: Translations<{
		name: string;
	}>;
}

class ArticleApi extends EntityApi<Article> {
	constructor() {
		super(ApiQueryKey.articles);
	}
}

export default new ArticleApi();
